import Loadable from '../../components/loadable';

const TemplateFiltersMobileView = Loadable({
  loader: () => import('../../pages/templates/template_filters_mobile_view'),
  type: 'modal',
});

angular.module('shared').value('TemplateFiltersMobileView', TemplateFiltersMobileView);
